import React, { Component, Fragment } from 'react';
import { defaultProps } from 'prism-react-renderer';

const logoPNG = 'https://cdn.gridbind.com/images/logo/gridbind-logo-minimal.png';
const logoSVG = 'https://cdn.gridbind.com/images/logo/gridbind-logo-minimal.png';

export default class VarexeLogo extends Component {

    static defaultProps = {
        type : 'svg'
    }

    constructor(props){

        super(props);
        this.state = {
            type : this.props.type

        }

    }


    componentDidMount(){

    }

    getImage = () => {

        switch(this.props.type) {
            case 'svg':
                return <img src={logoSVG} {...this.props} />;
            break;
            case 'svgIcon':
                return <img src={logoSVG} {...this.props} />;
            break;
            case 'png':
                return <img src={logoPNG} {...this.props} />;
            break;            
        }

    }

    render(){
        return(
            <Fragment>
                {this.getImage()}
            </Fragment>
        )
    }

}